// src/utils/GrammarRules.ts
// Módulo centralizado para reglas gramaticales por idioma
// Permite aplicar reglas de artículos y otras transformaciones según el idioma de forma escalable

export type SupportedLanguage = 'es' | 'de' | 'en' | 'fr' | 'it' | 'pt' | 'ru' | 'zh' | 'ja';

interface GrammarRuleSet {
    applyArticles: (text: string) => string;
    // Puedes agregar más funciones según crezcan las reglas
}

// Implementación de reglas para cada idioma
const grammarRules: Record<SupportedLanguage, GrammarRuleSet> = {
    es: {
        // Español: no modificar artículos, solo devolver el texto
        applyArticles: (text) => text,
    },
    de: {
        // Alemán: ejemplo simple, deberías expandir según tus necesidades
        applyArticles: (text) => {
            // Ejemplo: si el texto no empieza con un artículo alemán, sugerir uno (muy simplificado)
            const articles = ['der', 'die', 'das', 'ein', 'eine'];
            const firstWord = text.trim().split(' ')[0].toLowerCase();
            if (articles.includes(firstWord)) return text;
            // Por defecto, sugerir 'das' (esto debe mejorarse con lógica real)
            return `das ${text}`;
        },
    },
    en: {
        // Inglés: ejemplo simple
        applyArticles: (text) => text, // Puedes expandir para 'the', 'a', 'an'
    },
    fr: {
        applyArticles: (text) => text, // Francés: puedes expandir para 'le', 'la', 'un', 'une'
    },
    it: {
        applyArticles: (text) => text, // Italiano
    },
    pt: {
        applyArticles: (text) => text, // Portugués
    },
    ru: {
        applyArticles: (text) => text, // Ruso
    },
    zh: {
        applyArticles: (text) => text, // Chino
    },
    ja: {
        applyArticles: (text) => text, // Japonés
    },
};

// Función principal para aplicar reglas gramaticales según idioma
export function applyGrammarRules(text: string, lang: SupportedLanguage): string {
    const rules = grammarRules[lang];
    if (!rules) return text;
    return rules.applyArticles(text);
} 